import msgNotificacion from "../scripts/notification";

const getUrl = () => {  
  return `${process.env.REACT_APP_API_URL}/api`
}

const getToken = () => {
  let token = localStorage.getItem('accessToken')
  return `Bearer ${token}`;
}

const fnGet = (url) => {
  const urlRequest = `${getUrl()}/${url}`
  const abortController = new AbortController()
  const signal = abortController.signal

  return new Promise((resolve, reject) => {
    fetch(urlRequest, {
      method: 'GET',
      signal,
      mode: 'cors',
      cache: 'default',      
      headers: {
        "Authorization": getToken(),
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      credentials: 'include' // Importante para enviar cookies (si es necesario)
    }).then((result) => {
      if (result.ok) {
        resolve(result.json())
      } else {
        if (result.status === 401) {
          msgNotificacion(`Error de estatus: (${result.status.toString()}) ${result.statusText}`, 'warning')
          localStorage.removeItem("accessToken")
          localStorage.removeItem("user")
          localStorage.removeItem('dataImagen')

          window.location.href = "/";
        } else {
          msgNotificacion(`Error de API: (${result.status.toString()}) ${result.statusText}`, 'error')
        }
      }
    })
      .catch((error) => {
        if (error.name === 'AbortError') {
          abortController.abort();
          console.error('Petición cancelada')
        }

        reject(error);
      })
  })
}

const fnPost = (url, dataRequest) => {
  const urlRequest = `${getUrl()}/${url}`
  const abortController = new AbortController()
  const signal = abortController.signal

  return new Promise((resolve, reject) => {
    fetch(urlRequest, {
      method: 'POST',
      signal,
      body: JSON.stringify(dataRequest),
      mode: 'cors',
      cache: 'default',
      headers: {
        "Authorization": getToken(),
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      credentials: 'include' // Importante para enviar cookies (si es necesario)
    }).then((result) => {
      if (result.ok) {
        resolve(result.json())
      } else {
        console.log(result)
        if (result.status === 401) {
          msgNotificacion(`Error de estatus: (${result.status.toString()}) ${result.statusText}`, 'warning')
          localStorage.removeItem("accessToken")
          localStorage.removeItem("user")
          localStorage.removeItem('dataImagen')

          window.location.href = "/";
        } else {
          msgNotificacion(`Error de API: (${result.status.toString()}) ${result.statusText}`, 'error')
        }
      }
    })
      .catch((error) => {
        if (error.name === 'AbortError') {
          abortController.abort();
          console.error('Petición cancelada')
        }

        reject(error);
      });
  })
}

const fnPostUploadFile = (url, dataForm) => {
  const urlRequest = `${getUrl()}/${url}`
  const abortController = new AbortController()
  const signal = abortController.signal

  return new Promise((resolve, reject) => {
    fetch(urlRequest, {
      method: 'POST',
      signal,
      body: dataForm,
      mode: 'cors',
      cache: 'default',
      headers: {
        "Authorization": getToken()
      },
      credentials: 'include' // Importante para enviar cookies (si es necesario)
    }).then((result) => {
      if (result.ok) {
        resolve(result.json())
      } else {
        if (result.status === 401) {
          msgNotificacion(`Error de estatus: (${result.status.toString()}) ${result.statusText}`, 'warning')
          localStorage.removeItem("accessToken")
          localStorage.removeItem("user")
          localStorage.removeItem('dataImagen')

          window.location.href = "/";
        } else {
          msgNotificacion(`Error de API: (${result.status.toString()}) ${result.statusText}`, 'error')
        }
      }
    })
      .catch((error) => {
        if (error.name === 'AbortError') {
          abortController.abort();
          console.error('Petición cancelada')
        }

        reject(error);
      });
  })
}

const useFetch = {
  fnGet,
  fnPost,
  fnPostUploadFile
}

export default useFetch;